import React, { Component } from 'react';

export class ProfileIcon extends Component {
    render() {
        return (
            <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g id="profile_inactive_icon" transform="translate(16648.793 3962.793)">
                    <rect id="Rectangle_57" data-name="Rectangle 57" width="24" height="24" transform="translate(-16648.793 -3962.793)" fill="#fff" opacity="0" />
                    <path id="profile_active" d="M116.275,37.562c3.932,0,5.926-.827,6.453-1.108.273-.146,1.287-.765,1.107-1.3-.223-.663-1.6-.991-2.686-1.245-1.537-.361-2.88-.873-2.88-1.773,0-1.087,1.994-2.853,1.994-5.9a3.988,3.988,0,0,0-7.975,0c0,3.046,1.994,4.811,1.994,5.9,0,.9-1.343,1.412-2.88,1.773-1.085.254-2.463.582-2.686,1.245-.18.537.835,1.157,1.108,1.3.526.281,2.52,1.108,6.452,1.108Z" transform="translate(-16753.115 -3980.727)" fill="#666c77" />
                </g>
            </svg>
        );
    }
}

export class MenuIcon extends Component {
    render() {
        return (
            <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g id="profile_inactive_icon" transform="translate(16648.793 3962.793)">
                    <rect id="Rectangle_57" data-name="Rectangle 57" width="24" height="24" transform="translate(-16648.793 -3962.793)" fill="#fff" opacity="0" />
                    <path id="profile_active" d="M116.275,37.562c3.932,0,5.926-.827,6.453-1.108.273-.146,1.287-.765,1.107-1.3-.223-.663-1.6-.991-2.686-1.245-1.537-.361-2.88-.873-2.88-1.773,0-1.087,1.994-2.853,1.994-5.9a3.988,3.988,0,0,0-7.975,0c0,3.046,1.994,4.811,1.994,5.9,0,.9-1.343,1.412-2.88,1.773-1.085.254-2.463.582-2.686,1.245-.18.537.835,1.157,1.108,1.3.526.281,2.52,1.108,6.452,1.108Z" transform="translate(-16753.115 -3980.727)" fill="#666c77" />
                </g>
            </svg>
        );
    }
}


export class ProfileLabelIcon extends Component {
    render() {
        return (
            <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <g id="inactive" transform="translate(7013 -3480)">
                    <g id="Rectangle_1744" data-name="Rectangle 1744" transform="translate(-7013 3480)" fill="#fff" stroke="#707070" stroke-width="1" opacity="0">
                        <rect width="24" height="24" stroke="none" />
                        <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
                    </g>
                    <g id="Icon" transform="translate(-7012.25 3480.753)">
                        <circle id="Ellipse_882" data-name="Ellipse 882" cx="5.116" cy="5.116" r="5.116" transform="translate(5.669 1.244)" fill="#666c77" />
                        <path id="Path_62509" data-name="Path 62509" d="M12.11,21.153a5.809,5.809,0,0,1,.071-7.993q-.684-.053-1.4-.054A13.843,13.843,0,0,0,3.26,15.037a3.982,3.982,0,0,0-2.01,3.185v1.349a1.582,1.582,0,0,0,1.581,1.581Z" transform="translate(0 -0.828)" fill="#666c77" fill-rule="evenodd" />
                        <path id="Path_62510" data-name="Path 62510" d="M17.134,12.25a4.884,4.884,0,1,0,4.884,4.884A4.886,4.886,0,0,0,17.134,12.25Zm-.7,4.884v2.326a.7.7,0,1,0,1.4,0V17.134a.7.7,0,1,0-1.4,0Zm.7-3.023a.93.93,0,1,1-.93.93A.931.931,0,0,1,17.134,14.11Z" transform="translate(-0.767 -0.768)" fill="#666c77" fill-rule="evenodd" />
                    </g>
                </g>
            </svg>

        );
    }
}
